import type { Instance } from '@nx/state';

export const testMigrationPrefix = '[Testing] ';

export function isLiveMigration(migratedInstance: Instance): boolean {
  return !migratedInstance.name.startsWith(testMigrationPrefix);
}

export function kindOfMigration(migratedInstance: Instance): string {
  if (isLiveMigration(migratedInstance)) {
    return 'live';
  }
  return 'test';
}

export function kindOfMigrationFromBool(liveMigration: boolean): string {
  if (liveMigration) {
    return 'live';
  }
  return 'test';
}
